import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface Args {
  title?: string
  tooltip?: string
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
  Blocks: {
    default: unknown[]
  }
}

export const ReportingDashboardHeader: TOC<Signature> = <template>
  <div class="flex items-baseline justify-between" ...attributes>
    {{#if @title}}
      <h4 class="mt-0 mb-2 pr-4" data-test-dashboard-title-text>{{@title}}</h4>
    {{/if}}
    {{#if @tooltip}}
      <span data-test-reporting-dash-tooltip class="leading-none print:hidden">
        <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-3 w-3 cursor-pointer" />
        <Tooltip @text={{@tooltip}} />
      </span>
    {{/if}}
  </div>
</template>

export default ReportingDashboardHeader
